import React from 'react';
import TestimonialCard, { TestimonialCardProps } from '../TestimonialCard/TestimonialCard';
import LeftAlignedCarousel from 'molecules/LeftAlignedCarousel/LeftAlignedCarousel';

interface TestimonialVideoCardCarouselProps {
  cards: TestimonialCardProps[];
}

const TestimonialVideoCardCarousel = ({ cards }: TestimonialVideoCardCarouselProps): JSX.Element => {
  return (
    <LeftAlignedCarousel>
      {cards.map((card, index) => (
        <TestimonialCard
          key={index}
          {...card}
        />
      ))}
    </LeftAlignedCarousel>
  );
};

export default TestimonialVideoCardCarousel;
